
import { authService as service } from "./authService";
import { accountDeletionService } from "./accountDeletionService";

// Export all methods under a common namespace
export const authService = service;

// Export account deletion service
export { accountDeletionService };

// Export types from the auth service for convenience
export type { 
  SignUpData, 
  SignInData, 
  SignInResponse, 
  SignUpResponse 
} from './authService';

// Export default for consistency with other service modules
export default authService;
